import script from "./LearnMoreItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./LearnMoreItem.vue?vue&type=script&setup=true&lang=ts"

import "./LearnMoreItem.vue?vue&type=style&index=0&id=648b05b8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-648b05b8"]])

export default __exports__